//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiCheckboxMarkedCircleOutline,
  mdiCancel,
  mdiMinusCircleOutline,
  mdiArrowLeft,
  mdiWrenchOutline,
  mdiCloudUploadOutline,
} from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiCheckboxMarkedCircleOutline,
        mdiCancel,
        mdiMinusCircleOutline,
        mdiArrowLeft,
        mdiWrenchOutline,
        mdiCloudUploadOutline,
      },
    }
  },
}
